<form class="app-form">
  <h4>{{ 'LABELS.CREATE_NEW_PASSWORD' | translate }}</h4>
  <p>{{ 'MESSAGES.WARNINGS.PREVIOUS_PASSWORD_MUST_BE_DIFFERENT' | translate }}</p>

  <div class="form-group">
    <label class="col-form-label">{{ 'MESSAGES.PROMPTS.ENTER_PASSWORD' | translate }}</label>
    <div class="password">
      <code-input
        class="code-input"
        (codeChanged)="onPasswordChanged($event)"
        (codeCompleted)="onPasswordCompleted($event)"
        [codeLength]="4"
        [isCodeHidden]="true"
        id="password"
      >
      </code-input>
    </div>
  </div>

  <div class="form-group">
    <label class="col-form-label">{{ 'LABELS.CONFIRM_PASSWORD' | translate }}</label>
    <div class="password">
      <code-input
        class="code-input"
        (codeChanged)="onConfirmPasswordChanged($event)"
        (codeCompleted)="onConfirmPasswordCompleted($event)"
        [codeLength]="4"
        [isCodeHidden]="true"
        id="confirmPassword"
      >
      </code-input>
    </div>
  </div>

  <div class="form-group mt-6 mb-0">
    <button
      (click)="resetPassword()"
      [disabled]="!passcodeValue().valid"
      class="btn btn-gradient btn-block"
      type="button"
    >
      <span>{{ 'LABELS.RESET_PASSWORD' | translate }}</span>
    </button>
  </div>
</form>
